module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-01.a551523.jpg";